import {Modality, Operation} from "util/globalEnums";

export type ProcessTypeFull = `${Operation} ${Modality}`;
export type ProcessTypeShort =
  | "IA"
  | "EA"
  | "IM"
  | "EM"
  | "IT"
  | "ET"
  | "NA"
  | "NM"
  | "NT";

const getModalityAndOperation = (
  modality: Modality,
  operation: Operation,
): {full: ProcessTypeFull; short: ProcessTypeShort} => {
  if (!modality || !operation) {
    return {full: "Importação Marítima", short: "IM"};
  }

  const full: ProcessTypeFull = `${operation} ${modality}`;
  const short: ProcessTypeShort =
    `${operation?.charAt(0)}${modality?.charAt(0)}` as ProcessTypeShort;

  return {full, short};
};

export default getModalityAndOperation;
